import {Component, inject} from '@angular/core';
import {GraphMathiaService} from '../../services/graph-mathia.service';
import {
    GraphMathiaAuthorizationService
} from '@modules/graph-mathia/core/services/graph-mathia-authorization.service';
import {timer} from 'rxjs/internal/observable/timer';
import {isMobile} from 'shared/utils/navigator';
import {isMobileAlert, mobileUrlRedirection} from '../../../../../settings/amazon_python';
import {MobileRedirectionModalComponent} from 'fuse-core/components/mobile-redirection-modal/mobile-redirection-modal.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
    selector: 'app-multi-graph-view',
    templateUrl: './multi-graph-view.component.html',
    standalone: false
})
export class MultiGraphViewComponent {
    private dialog = inject(MatDialog);

    constructor(
        private graphService: GraphMathiaService,
        private graphMathiaAuthorizationService: GraphMathiaAuthorizationService
    ) {
        timer(1000).subscribe(() => {
            // isMobileAlert is used to show a msg mobile not supported but without redirection
            if (isMobile() && (mobileUrlRedirection || isMobileAlert)) {
                const dialogRef = this.dialog.open(
                    MobileRedirectionModalComponent,
                    {}
                );
                dialogRef.afterClosed().subscribe((result) => {
                    // isMobileAlert => no redirection only alert
                    if (result && !isMobileAlert) {
                        window.location.href = mobileUrlRedirection;
                    }
                });
            }
        });
    }

    graphsAreAvailable(): boolean {
        return this.graphService.graphsAreAvailable();
    }

    public get rolesCanShowBannerInfo(): boolean {
        return this.graphMathiaAuthorizationService.rolesCanShowBannerInfo;
    }
}
